import React from 'react';
import { User, Settings, Zap, RotateCcw } from 'lucide-react';

const Onboarding = () => {
  const steps = [
    {
      number: "1",
      icon: <User className="h-8 w-8 text-burnt-orange" />,
      title: "Intake",
      description: "your priorities, pain points, tools, preferences"
    },
    {
      number: "2", 
      icon: <Settings className="h-8 w-8 text-burnt-orange" />,
      title: "Setup",
      description: "email rules, calendar rules, templates, access boundaries"
    },
    {
      number: "3",
      icon: <Zap className="h-8 w-8 text-burnt-orange" />,
      title: "First-week stabilization",
      description: "triage + quick wins"
    },
    {
      number: "4",
      icon: <RotateCcw className="h-8 w-8 text-burnt-orange" />,
      title: "Weekly rhythm",
      description: "planning + execution + reviews"
    }
  ];

  return (
    <section id="onboarding" className="section-padding bg-gray-50">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Onboarding that doesn't waste your time.
          </h2>
        </div>

        {/* Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="text-center space-y-4 animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="relative">
                  <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto card-shadow">
                    {step.icon}
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-burnt-orange text-white rounded-full flex items-center justify-center font-bold text-sm">
                    {step.number}
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-olive-brown mb-3">
                    Step {step.number}: {step.title}
                  </h3>
                  <p className="text-olive-brown/70 leading-relaxed text-sm">
                    ({step.description})
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom Message */}
          <div className="text-center">
            <p className="text-burnt-orange font-medium italic">
              Most clients feel relief within the first 7–14 days.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Onboarding;